import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { PourFormatsCard } from './components/PourFormatsCard';
import { ServingContainerDeleteCard } from './components/ServingContainerDeleteCard';
import { ServingContainerDetailsCard } from './components/ServingContainerDetailsCard';

export function ServingContainerDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const servingContainerQueryResults = useQuery({
        queryKey: ['servingContainer', id],
        queryFn: () =>
            Api.Servings.ServingContainer.getServingContainer(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={servingContainerQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <ServingContainerDetailsCard
                                servingContainer={data}
                            />
                            <PourFormatsCard servingContainer={data} />

                            <Can I="delete" a="Product">
                                <ServingContainerDeleteCard
                                    servingContainer={data}
                                />
                            </Can>
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
